<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon_list_wallet" clip-path="url(#clip0_1090_91)">
      <g id="icon_list_wallet_2">
        <g id="&#234;&#183;&#184;&#235;&#163;&#185; 8627">
          <path
            id="account_balance_wallet_FILL1_wght400_GRAD0_opsz48"
            d="M2.577 20.922C2.37277 20.9201 2.17099 20.8772 1.9836 20.796C1.79621 20.7147 1.62701 20.5968 1.486 20.449C1.33278 20.309 1.21043 20.1386 1.12675 19.9487C1.04307 19.7588 0.999899 19.5535 1 19.346V3.577C1.00245 3.37164 1.04682 3.16894 1.13039 2.98133C1.21396 2.79373 1.33497 2.62517 1.486 2.486C1.62517 2.33497 1.79373 2.21396 1.98133 2.13039C2.16894 2.04682 2.37164 2.00245 2.577 2H18.346C18.553 2.00032 18.7577 2.04368 18.9471 2.12735C19.1365 2.21102 19.3064 2.33315 19.446 2.486C19.5938 2.62701 19.7117 2.79621 19.793 2.9836C19.8742 3.17099 19.9171 3.37277 19.919 3.577V5H11.986C11.5213 4.98514 11.0585 5.06534 10.6259 5.23569C10.1934 5.40603 9.80015 5.66293 9.47038 5.99064C9.14062 6.31835 8.88126 6.70995 8.7082 7.14145C8.53515 7.57295 8.45205 8.03525 8.464 8.5V14.466C8.45205 14.9308 8.53515 15.393 8.7082 15.8245C8.88126 16.256 9.14062 16.6477 9.47038 16.9754C9.80015 17.3031 10.1934 17.56 10.6259 17.7303C11.0585 17.9007 11.5213 17.9809 11.986 17.966H19.923V19.359C19.9129 19.7741 19.7434 20.1693 19.4499 20.4629C19.1563 20.7564 18.7611 20.9259 18.346 20.936L2.577 20.922Z"
            fill="#3CB149"
          />
          <path
            id="account_balance_wallet_FILL1_wght400_GRAD0_opsz48_2"
            d="M12.4048 16.3759C12.145 16.3891 11.8852 16.3492 11.6412 16.2588C11.3973 16.1684 11.1743 16.0293 10.9858 15.8499C10.808 15.6657 10.6697 15.4471 10.5793 15.2076C10.4888 14.9681 10.4482 14.7127 10.4598 14.4569V8.49092C10.4458 8.23296 10.4853 7.97488 10.5758 7.73292C10.6663 7.49095 10.8059 7.27033 10.9858 7.08492C11.1763 6.90943 11.4 6.77374 11.6437 6.68582C11.8873 6.5979 12.1461 6.55952 12.4048 6.57292H19.4748C19.7335 6.55952 19.9923 6.5979 20.2359 6.68582C20.4796 6.77374 20.7033 6.90943 20.8938 7.08492C21.0735 7.27041 21.2129 7.49107 21.3033 7.73303C21.3936 7.97499 21.433 8.23303 21.4188 8.49092V14.4569C21.4304 14.7127 21.3898 14.9681 21.2993 15.2076C21.2089 15.4471 21.0706 15.6657 20.8928 15.8499C20.7043 16.0293 20.4813 16.1684 20.2374 16.2588C19.9934 16.3492 19.7336 16.3891 19.4738 16.3759H12.4048Z"
            fill="#FFC304"
          />
          <path
            id="account_balance_wallet_FILL1_wght400_GRAD0_opsz48_3"
            d="M14.2592 13.1428C14.4788 13.1418 14.6959 13.0958 14.8971 13.0078C15.0983 12.9197 15.2794 12.7915 15.4292 12.6308C15.5921 12.4765 15.7216 12.2904 15.8097 12.084C15.8978 11.8775 15.9425 11.6552 15.9412 11.4308C15.9407 11.2132 15.895 10.998 15.8068 10.7989C15.7187 10.5999 15.5901 10.4214 15.4292 10.2748C15.278 10.1169 15.0965 9.99131 14.8955 9.90547C14.6945 9.81964 14.4782 9.77539 14.2597 9.77539C14.0411 9.77539 13.8248 9.81964 13.6238 9.90547C13.4228 9.99131 13.2413 10.1169 13.0902 10.2748C12.9292 10.4214 12.8006 10.5999 12.7125 10.7989C12.6243 10.998 12.5786 11.2132 12.5782 11.4308C12.5768 11.6552 12.6215 11.8775 12.7096 12.084C12.7977 12.2904 12.9272 12.4765 13.0902 12.6308C13.2398 12.7913 13.4207 12.9196 13.6218 13.0076C13.8228 13.0956 14.0397 13.1417 14.2592 13.1428Z"
            fill="#363C43"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1090_91">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
